<template>
  <v-card>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container>
        <v-layout>
          <v-flex xs12 md4>
            <v-text-field
              v-model="email"
              :rules="emailRules"
              label="E-mail"
              prepend-icon="alternate_email"
              class="purple-input"
              @keyup.enter="validate"
            />
          </v-flex>
          <v-flex xs12 md4>
            <v-select
              v-model="groups"
              :items="groupList"
              label="Grupos"
              multiple
              chips
              hint="(opcional)"
              persistent-hint
              item-text="label"
              item-value="value"
            >
              <template v-slot:prepend-item>
                <v-list-tile ripple @click="toggle">
                  <v-list-tile-action>
                    <v-icon
                      :color="groups.length > 0 ? 'indigo darken-4' : ''"
                      >{{ icon }}</v-icon
                    >
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Selecionar todos</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-select>
          </v-flex>

          <v-flex xs12 md3 d-flex>
            <v-flex xs6 md6 class="text-lg-right">
              <v-btn
                color="primary"
                @click="validate()"
                :disabled="!valid || loading"
                :loading="loading"
                small
                outline
                slot="start"
              >
                <v-icon>search</v-icon>Buscar
              </v-btn>
            </v-flex>
            <v-spacer />
            <v-flex xs6 md6 v-if="isAdmin || isFinancial || isAccessGrantor">
              <v-btn
                color="success"
                @click="openUserForm('new')"
                :disabled="loading"
                small
                outline
                slot="end"
              >
                <v-icon class="pr-1">receipt_long</v-icon>Adicionar
              </v-btn>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <user-form />
  </v-card>
</template>
<script>
import { eventBus } from "@/main";
import { mapActions, mapState } from "vuex";
import UserForm from "./UserForm.vue";

export default {
  components: {
    UserForm,
  },
  data: () => ({
    valid: false,
    // loading: false,
    email: null,
    groups: [],
    emailRules: [true],

    // emailRules: [
    //   v => !v && (!this.groups && this.groups.length > 0) || 'Por favor, preencher o email.'
    // ],
  }),
  async created() {
    // console.log('created power_plants: ', this.power_plants)
    if (this.filters && this.filters.power_plant) {
      this.power_plant = this.filters.power_plant;
    }
    if (this.filters && this.filters.competence) {
      this.competence = this.filters.competence;
    }
  },
  computed: {
    ...mapState("configuration", ["users", "loading", "filter"]),
    ...mapState(["groupList", "user"]),
    filter: {
      get() {
        // console.log('status: ', this.$store.state.billing.billingFilters.status)
        return this.$store.state.configuration.filter;
      },
      set(value) {
        this.$store.commit("configuration/setFilter", value);
      },
    },
    likesAllGroups() {
      return this.groups.length === this.groupList.length;
    },
    likesSomeGroups() {
      return this.groups.length > 0 && !this.likesAllGroups;
    },
    icon() {
      if (this.likesAllGroups) return "mdi-close-box";
      if (this.likesSomeGroups) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    isAdmin() {
      let currentUserGroups = this.user.group.toString();
      if (currentUserGroups.indexOf("admin") >= 0) {
        return true;
      }
      return false;
    },
    isFinancial() {
      let currentUserGroups = this.user.group.toString();
      if (currentUserGroups.indexOf("financial") >= 0) {
        return true;
      }
      return false;
    },
    isAccessGrantor() {
      let currentUserGroups = this.user.group.toString();
      if (currentUserGroups.indexOf("access_grantor") >= 0) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions("configuration", ["getUsersByParams"]),
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllGroups) {
          this.groups = [];
        } else {
          this.groups = this.groupList.slice().map((item) => item.value);
        }
      });
    },
    async validate() {
      // console.log('validate: ', this.$refs.form.validate())
      if (this.$refs.form.validate()) {
        this.valid = true;
        // console.log('this.power_plant: ', this.power_plant.id)
        // console.log('this.competence: ', this.competence)
        // console.log('this.status: ', this.status)
        let params = {
          email: this.email,
          groups: this.groups,
        };

        await this.getUsersByParams(params);
      }
    },
    // filterPowerPlants(_powerplants) {
    //   var PowerPlantArray = []
    //   if(_powerplants && this.user) {
    //     if(this.user.group
    //         && (this.user.group.indexOf('admin') >= 0 ||
    //           this.user.group.indexOf('financial') >= 0))
    //       return _powerplants
    //     const user_pp = this.user.powerplants || this.user.power_plants

    //     if(user_pp && user_pp.length > 0) {
    //       _powerplants.filter((power_plant) => {
    //         return user_pp.filter((power_plant2) => {
    //           if(power_plant2.power_plant_id === power_plant.id) {
    //             PowerPlantArray.push(power_plant)
    //           }
    //         })
    //       });
    //     }
    //   }
    //   return PowerPlantArray
    // },
    openUserForm(type, data) {
      let obj = {
        status: true,
        type: type,
        data: data,
        isAdmin: this.isAdmin,
      };
      eventBus.$emit("userForm", obj);
    },
  },
};
</script>
